
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("6wxEl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $80tmL = parcelRequire("80tmL");
function $4bffd55cbb00ede2$var$_toConsumableArray(r) {
    return $4bffd55cbb00ede2$var$_arrayWithoutHoles(r) || $4bffd55cbb00ede2$var$_iterableToArray(r) || $4bffd55cbb00ede2$var$_unsupportedIterableToArray(r) || $4bffd55cbb00ede2$var$_nonIterableSpread();
}
function $4bffd55cbb00ede2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4bffd55cbb00ede2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4bffd55cbb00ede2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4bffd55cbb00ede2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4bffd55cbb00ede2$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $4bffd55cbb00ede2$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $4bffd55cbb00ede2$var$_arrayLikeToArray(r);
}
function $4bffd55cbb00ede2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// import $ from "jquery";
/**
 * Utility to select all panel's content blocks.
 * Simplified version to use instead of bootstrap.Collapse()
 *
 * @param {String} selector - panel selector to get elements set with jQuery
 * @param {String} panelClass - panel className as BEM CSS block ('panel' is default)
 */ // export const attachPanelsHandler = (selector, panelClass = 'panel') => {
//   const targets = Array.from(document.querySelectorAll(selector));
//   targets.forEach(elem => {
//     const panelBtn = $(elem).prev();
//     const panelBlock = panelBtn.parent();
//     if ($(elem).hasClass('show')) {
//       $(elem).slideUp(500).removeClass('show');
//       panelBtn.removeClass(panelClass + '__btn--open');
//       panelBtn.children('button').attr('aria-expanded', 'false');
//       if (panelBlock.hasClass('active')) {
//         panelBlock.removeClass('active');
//       }
//     } else {
//       $(elem).slideDown(500).addClass('show');
//       panelBtn.addClass(panelClass + '__btn--open');
//       panelBtn.children('button').attr('aria-expanded', 'true');
//       if (panelBlock.hasClass('active')) {
//         panelBlock.addClass('active');
//       }
//     }
//   });
// };
// export const init = () => {
//   $("section .panel").on("click", (ev) => {
//     const elem = ev.target;
//     const btn = $(elem).closest(".panel__btn");
//     if (btn.length) {
//       const target = btn.find("button[data-target]").data("target");
//       attachPanelsHandler(target);
//     }
//   });
// };
var $4bffd55cbb00ede2$var$init = module.exports.init = function init() {
    // Init panels
    var collapseElementList = document.querySelectorAll(".collapse");
    var collapseList = $4bffd55cbb00ede2$var$_toConsumableArray(collapseElementList).map(function(collapseEl) {
        return new $80tmL.Collapse("#" + collapseEl.id, {
            toggle: false
        });
    });
    collapseList.forEach(function(elem) {
        elem._element.addEventListener("hide.bs.collapse", function(e) {
            // console.log('Hides', e, e.target);
            e.target.parentElement.classList.remove("panel--open");
        });
        elem._element.addEventListener("show.bs.collapse", function(e) {
            e.target.parentElement.classList.add("panel--open");
        });
    });
};

});

parcelRegister("jHMUv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e587f90d126edbfb$export$581ff339ea0ba762; });

var $5gKb4 = parcelRequire("5gKb4");
function $e587f90d126edbfb$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5gKb4._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("5gKb4", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $3d624443cd99befe$export$1e71eb4bef00f6b0; });
function $3d624443cd99befe$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hYccX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d15182816097eec3$export$4fa2f4023c9cbda5; });
function $d15182816097eec3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d15182816097eec3$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d15182816097eec3$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=panel.module.f3d560b6.js.map
